export const templates = {
  title: 'Contract templates',
  newTemplate: 'New contract template',
  noTemplates: 'No templates',
  placeholder: {
    search: 'Search...',
  },
  filter: {
    allTypes: 'All types',
    contract: 'Contract',
    quotation: 'Quotation',
    other: 'Other',
  },
  fields: {
    name: 'Name',
    description: 'Description',
    type: 'Type',
    createdAt: 'Created at',
    usageCount: 'Usage count',
    actions: 'Actions',
    organization: 'Organization'
  },
  types: {
    contract: 'Contract',
    quotation: 'Quotation',
    other: 'Other',
  },
  actions: {
    download: 'Download',
    preview: 'Preview',
    delete: 'Delete',
    deleteSelected: 'Delete Selected'
  },
  deleteModal: {
    title: 'Contract template deletion',
    message: 'Are you sure you want to delete this contract template?',
    warning: 'This action cannot be undone.',
    cancel: 'Cancel',
    delete: 'Delete'
  },
  bulkDeleteModal: {
    title: 'Delete Multiple Templates',
    message: 'Are you sure you want to delete {{count}} selected templates?',
    warning: 'This action cannot be undone and will affect all selected templates.'
  },
  createTemplateModal: {
    title: 'New contract template creation',
    description: "New contract template creation with name and description.",
    name: 'Contract template name',
    namePlaceholder: 'Add the contract template name',
    descriptionPlaceholder: 'Add the contract template description',
    documentType: 'Document type',
    uploadTemplate: 'Upload contract template',
    uploadTemplateDescription: 'Upload contract template',
    cancel: 'Cancel',
    uploading: 'Uploading...',
    uploadSuccess: 'Upload successful',
    createTemplate: 'Create contract template',
    contract: 'Contract',
    quotation: 'Quotation',
    supportedFormat: 'Supported format: .docx',
    availableFields: 'Available fields',
    organization: 'Organization',
    selectOrganization: 'Select organization',
    fieldsDescription: 'The fields listed in the template document will be automatically filled in based on the {{type}} data. You can also add additional fields to the document in the {{format}} format, which will need to be manually filled in during generation.',
  },
  messages: {
    created: 'Contract template created successfully',
    error: 'Error occurred while creating the contract template',
    deleted: 'Contract template deleted successfully',
    deleteError: 'Error occurred while deleting the template',
    bulkDeleted: '{{count}} templates successfully deleted',
    bulkDeleteError: 'Error occurred while deleting multiple templates',
    noTemplatesSelected: 'No templates selected for deletion'
  },
  selected: 'selected'
}
